import React, { useState } from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Tab, Tabs, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
  Title,
  SubTitle
} from './style'
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
      style={{ fontSize: '13px', width: '650px' }}
    >
      {value === index && (
        <Box p={2}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    width: '100%'
    //height: 224,
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
}));

const CoupousInfo = ({
  value,
  setValue,
  open,
  setOpen
}) => {
  const classes = useStyles();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open} fullWidth={true} maxWidth={'md'}>
      <DialogTitle id="customized-dialog-title" onClose={handleClose}>
        Saiba Mais
      </DialogTitle>
      <DialogContent dividers>
        <div className={classes.root}>
          <Tabs
            orientation="vertical"
            variant="scrollable"
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
          textColor="primary"
            aria-label="Vertical tabs example"
            className={classes.tabs}
          >
            <Tab inkBarStyle={{background: 'blue'}} label="Informações" {...a11yProps(0)} />
            <Tab label="Configurações do valor" {...a11yProps(1)} />
            <Tab label="Descrição" {...a11yProps(2)} />
            <Tab label="Restrições" {...a11yProps(3)} />
          </Tabs>
          <TabPanel value={value} index={0}>
            <Title>Informações</Title>
            <SubTitle>Nome</SubTitle>
            <p>Campo para inserir o nome que será exibido para o Cupom.</p>
            <SubTitle>Quantidade total de usos do Cupom</SubTitle>
            <p>Campo para inserir o total de Cupons disponíveis para uso.</p>
            <SubTitle>Total por Usuário</SubTitle>
            <p>Campo para inserir a quantidade de Cupons que cada usuário pode utilizar.</p>
            <p>- Por exemplo: se o “Total” for 1000 e o “Total por Usuário” for 1: nessa situação, serão disponibilizados 1000 Cupons, mas cada usuário só poderá utilizar 1; quando os 1000 Cupons forem utilizados, nenhum usuário poderá mais utilizar esse Cupom.</p>
            <SubTitle>Data de Expiração</SubTitle>
            <p>Campo para inserir a data de expiração do Cupom (data a partir da qual, o Cupom não poderá mais ser utilizado).</p>
            <SubTitle>Primeiro Uso</SubTitle>
            <p>Campo para selecionar se o Cupom será válido apenas para o primeiro uso no App ou no Estabelecimento (caso não seja selecionado nem App nem Estabelecimento, o Cupom será válido em qualquer acesso, mesmo que não seja primeiro uso).</p>
            <SubTitle>Checkbox Tornar visível na sessão de cupom</SubTitle>
            <p>Ao ser selecionado, indica que o Cupom será aplicado automaticamente às compras dos usuários.</p>
            <SubTitle>Checkbox Visualizador na lista de lojas</SubTitle>
            <p>Ao ser selecionado, indica que o Cupom será visível na Lista de Estabelecimentos do Aplicativo.</p>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Title>Configurações do valor</Title>
            <SubTitle>Tipo Valor Cupom</SubTitle>
            <p> Campo para selecionar o tipo de valor do Cupom:</p>
            <p>- Absoluto: o valor do Cupom será exatamente o que for inserido para ele. Por exemplo, se o um Cupom Absoluto for de R$ 30,00, em uma compra no valor de R$ 50,00, o desconto seria de R$ 30,00 mesmo (valor absoluto), ou seja, o usuário iria pagar apenas R$ 20,00 nela.</p>
            <p>- Porcentagem: o valor do Cupom será o percentual do valor da compra. Por exemplo, se a Porcentagem configurada para o Cupom for 40%, em uma compra no valor de R$ 100,00, o desconto seria de R$ 40,00 (40%), ou seja, o usuário iria pagar apenas R$ 60,00 nela.</p>
            <SubTitle>Valor</SubTitle>
            <p>Campo para inserir o valor do Cupom (se for do tipo Absoluto será um valor em R$; se for do tipo Porcentagem, será um valor percentual).</p>
            <SubTitle>Valor Mínimo por Transação</SubTitle>
            <p>Campo para inserir o valor mínimo do pedido para que o pedido possa ser utilizado.</p>
            <SubTitle>Valor Máximo do Desconto</SubTitle>
            <p>Campo para inserir o valor máximo que será dado de desconto na compra.</p>

            <p>Exemplo: supondo que:</p>
            <ul>
              <li>o Cupom é de R$ 30,00 (Absoluto);</li>
              <li>o Valor Mínimo por Transação é de R$ 30,00;</li>
              <li>o Valor Máximo por Transação é de R$ 200,00.</li>
            </ul>

            <p>Nessa situação, o usuário só poderá usar esse Cupom em compras entre R$ 30,00 e 200,00.</p>
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Title>Descrição</Title>
            <SubTitle>Descrição</SubTitle>
            <p>Campo para inserir a descrição completa do Cupom. </p>
          </TabPanel>
          <TabPanel value={value} index={3}>
            <Title>Restrições</Title>
            <SubTitle>Disponível para todos usuários?</SubTitle>
            <p>- ao selecionar “Sim”, indica que o Cupom estará disponível para todos os usuários.</p>
            <p>- ao selecionar “Não”, serão exibidas os checkbox para identificar se os usuários poderão ou não utilizar o Cupom, bem como o campo para inserir os usuários que estarão nessa restrição. </p>
            <SubTitle>Disponível em todos estabelecimentos?</SubTitle>
            <p>- ao selecionar “Sim”, indica que o Cupom estará disponível para todos os Estabelecimentos.</p>
            <p>- ao selecionar “Não”, exibe o campo para inserir os Estabelecimentos nos quais o Cupom estará disponível. </p>
            <SubTitle>Disponível em todos horários?</SubTitle>
            <p>- ao selecionar “Sim”, indica que o Cupom estará disponível em todos os dias e horários.</p>
            <p>- ao selecionar “Não”, serão exibidos os checkbox para selecionar os dias da semana, bem como os campos para inserir os horários disponíveis e o botão para adicionar esses horários na tabela abaixo. </p>
            <SubTitle>Aplicável a todas categorias do cardápio?</SubTitle>
            <p>- ao selecionar “Sim”, indica que o Cupom estará disponível para todas as Categorias do Cardápio.</p>
            <p>- ao selecionar “Não”, exibe o campo para inserir as Categorias nas quais o Cupom não estará disponível. </p>
            <SubTitle>Aplicável em todos produtos do cardápio?</SubTitle>
            <p>- ao selecionar “Sim”, indica que o Cupom estará disponível para todos os Produtos do Cardápio.</p>
            <p>- ao selecionar “Não”, exibe o campo para inserir os Produtos nos quais o Cupom não estará disponível.</p>
            <SubTitle>Disponível em todas modalidades?</SubTitle>
            <p>- ao selecionar “Sim”, indica que o Cupom estará disponível em todas as Modalidades de Retirada.</p>
            <p>- ao selecionar “Não”, serão exibidos os checkbox para selecionar as Modalidades nas quais o Cupom estará disponível – ao selecionar as Modalidades “Quero Levar”, “Receber no Escritório” ou “Delivery”, serão disponibilizados logo abaixo os seguintes campos (um para cada Modalidade selecionada):</p>
            <p>Checkbox Habilitar Desconto sobre Taxa: ao ser selecionado, habilita os campos seguintes referentes à Modalidade selecionada.</p>
            <p><strong>Tipo Valor Cupom:</strong> campo para selecionar o tipo de valor do Cupom para a taxa:</p>
            <p>- Absoluto: o valor do Cupom será exatamente o que for inserido para ele. Por exemplo, se o um Cupom Absoluto for de R$ 10,00, em uma compra com a taxa no valor de R$ 15,00, o desconto seria de R$ 10,00 mesmo (valor absoluto), ou seja, o usuário iria pagar apenas R$ 5,00 de taxa.</p>
            <p>- Porcentagem: o valor do Cupom será o percentual do valor da taxa. Por exemplo, se a Porcentagem configurada para a taxa for 40%, em uma compra com valor de taxa de R$ 10,00, o desconto seria de R$ 4,00 (40%), ou seja, o usuário iria pagar apenas R$ 6,00 de taxa.</p>
            <p><strong>Valor:</strong> campo para inserir o valor do Cupom para a taxa (se for do tipo Absoluto será um valor em R$; se for do tipo Porcentagem, será um valor percentual).</p>
            <p><strong>Valor Máximo de Desconto por Taxa:</strong> campo para inserir o valor máximo que o desconto pode atingir para uma taxa. Por exemplo:</p>
            <p>- Valor do Cupom para Taxa: 90% (percentual)</p>
            <p>- Valor da Taxa: R$ 10,00</p>
            <p>- Valor Máximo de Desconto por Taxa: R$ 6,00</p>
            <p>Nessa situação, o usuário deveria pagar apenas R$ 1,00 de taxa (90% de desconto sobre R$ 10,00, ou seja R$ 9,00 de desconto); porém como o valor máximo de desconto por taxa é de R$ 6,00, esse valor será aplicado e o usuário irá pagar R$ 4,00 de taxa.</p>
            <p><strong>Valor Mínimo da Taxa:</strong> campo para inserir o valor mínimo de taxa para que o desconto seja aplicado nela. Por exemplo:</p>
            <p>- Valor do Cupom para Taxa: 90% (percentual)</p>
            <p>- Valor da Taxa: R$ 5,00</p>
            <p>- Valor Mínimo da Taxa: R$ 6,00</p>
            <p>Nessa situação, o desconto não seria aplicado pois a taxa (R$ 5,00) é menor do que o valor mínimo (R$ 6,00).</p>
          </TabPanel>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default CoupousInfo
